import React from 'react';
import bannerImage from "../img/aaaservices/virtual.webp";
import brochure from '../img/TOOL & FIXURE DESIGN BROCHURE V3.pdf';

import PCMobileApplications from './PCMobileApplications';

const gamingpage = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = brochure;
    link.download = 'Brochure.pdf';
    link.click();
  };

  const handleEnquiry = () => {
    console.log("Enquiry button clicked");
  };

  return (
    <div>
      {/* Banner Image */}
      {/* <div>
        <img
          src={bannerImage}
          alt="Banner"
          style={{ width: '100%', height: 'auto', maxHeight: '600px', objectFit: 'cover' }}
        />
      </div> */}
      
      <PCMobileApplications />
      
    </div>
  );
};

export default gamingpage;
